import configurator from '~/services/Configurator';

const getFullPathUrlOrDefault = (url: string | null | undefined, defaultValue: string | null = null): string | null => {
  return url ? `${configurator.config.publicAssetsUrl}/${url}` : defaultValue;
};

export default getFullPathUrlOrDefault;
